import { useEffect, useState } from 'react';

import { getMe } from '@entities/auth/api/auth';
import tryRefreshAccessToken from '@entities/auth/lib/tryRefreshAccessToken';
import useAuthStore from '@entities/auth/model/useAuthStore';
import { isMobileApp } from '@shared/utils/fcmToken';

/**
 * MobileAuthPreloader
 *
 * 모바일 앱(Flutter WebView) 환경에서 앱 최상단에서 즉시 Refresh Token으로
 * 세션 복구를 시도합니다. 페이지 로드 직후 실행되어 재접속 시 자동 로그인을 보장합니다.
 *
 * [수정] isMobileApp() 의존 제거 - 앱 재실행 시 타이밍 이슈로 false가 될 수 있음
 * - 토큰이 없고 모바일 UA면 무조건 refresh 시도 (쿠키 있으면 복구, 없으면 실패로 로그인 폼)
 * - 웹(데스크톱): refresh 시도하지 않음 (쿠키 없을 가능성 높음)
 */
function MobileAuthPreloader({ children }) {
  const [isPreloading, setIsPreloading] = useState(true);

  useEffect(() => {
    // 웹(데스크톱)은 refresh 시도 생략 - 쿠키 없을 가능성 높음
    if (!isMobileApp()) {
      setIsPreloading(false);
      return;
    }

    let cancelled = false;

    async function tryPreload() {
      try {
        const newAccessToken = await tryRefreshAccessToken();
        if (cancelled) return;
        if (!newAccessToken) {
          return;
        }

        const { setAccessToken, setAuth } = useAuthStore.getState();
        setAccessToken(newAccessToken);

        const meResponse = await getMe();
        if (cancelled) return;
        const { enumber, companyCode, ...userData } = meResponse.resultData;
        setAuth({ ...userData }, newAccessToken, enumber, companyCode);
      } catch {
        // refresh 실패 시 무시 (LoginPage에서 로그인 폼 표시)
      } finally {
        if (!cancelled) {
          setIsPreloading(false);
        }
      }
    }

    tryPreload();
    return () => {
      cancelled = true;
    };
  }, []);

  if (isPreloading) {
    return null;
  }

  return children;
}

export default MobileAuthPreloader;
